import React, { useContext } from "react";
import wish from "../Assets/unwish.svg";
import wishFilled from "../Assets/wish.svg";
import { ShopContext } from "../../Context/ShopContext";

const WishlistButton = ({ productId, isWishlisted }) => {
    const { toggleWishlist } = useContext(ShopContext);

    return (
        <button
            type="button"
            className="wishlist-btn"
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                toggleWishlist(productId);
            }}
        >
            <img
                src={isWishlisted === 1 ? wishFilled : wish}
                alt="wishlist"
                className="wishlist-icon"
                height={10}
                width={10}
            />
        </button>
    );
};

export default WishlistButton;
